import { ChainId } from '@pancakeswap/sdk'
import { Address } from 'wagmi'

export const WBETH: Record<number, Address> = {
}

export const SNBNB: Record<number, Address> = {
}
